
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import LandingPage from "./pages/LandingPage";
import AboutPage from "./pages/AboutPage";
import VisionPage from "./pages/VisionPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import SecurityPage from "./pages/SecurityPage";
import MerchandisePage from "./pages/MerchandisePage";
import PledgeSuccess from "./pages/PledgeSuccess";
import PledgeError from "./pages/PledgeError";
import NotFound from "./pages/NotFound";

/**
 * Main App component with routing
 * Streamlined pledge-only flow - no authentication required
 */
const queryClient = new QueryClient();

const App = () => (
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <Helmet>
        <link rel="preload" href="/about" as="document" />
        <link rel="preload" href="/vision" as="document" />
        <link rel="preload" href="/contact" as="document" />
      </Helmet>
      <Toaster />
      <Sonner />
      <Routes>
        {/* Public landing and informational pages */}
        <Route path="/landing" element={<Navigate to="/" replace />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/vision" element={<VisionPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/merchandise" element={<MerchandisePage />} />
        
        {/* Pledge flow pages */}
        <Route path="/pledge-success" element={<PledgeSuccess />} />
        <Route path="/pledge-error" element={<PledgeError />} />
        
        {/* Redirect old auth route */}
        <Route path="/auth" element={<Navigate to="/" replace />} />
        
        {/* Handle 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </QueryClientProvider>
  </BrowserRouter>
);

export default App;
